import { styled } from "@mui/material/styles";

export const Root = styled("div")(({ theme }) => ({
  height: "100%",
  display: "inline-flex",
  alignItems: "flex-end",
  justifyContent: "center",
  [theme.breakpoints.up("tablet")]: {
    justifyContent: "flex-start",
    alignItems: "center",
  },
}));
